import { useEffect } from "react";

export default function AboutKryzen() {
  useEffect(() => {
    const elements = document.querySelectorAll(".reveal");

    const onScroll = () => {
      elements.forEach((el) => {
        const rect = el.getBoundingClientRect();
        if (rect.top < window.innerHeight - 80) {
          el.classList.add("active");
        }
      });
    };

    window.addEventListener("scroll", onScroll);
    onScroll(); // Trigger once on load

    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div
      className="about-wrapper"
      style={{
        padding: "80px 20px",

      }}
    >
      <style>{`
      /* ------------------------------------
         GRID & BASIC DESIGN
      -------------------------------------*/
      .about-container {
        max-width: 1150px;
        margin: 0 auto;
      }

      .about-title {
        font-size: 40px;
        font-weight: 800;
        color: #0f172a;
        text-align: center;
        margin-bottom: 20px;
      }

      .about-subtitle {
        font-size: 18px;
        color: #475569;
        text-align: center;
        max-width: 850px;
        margin: 0 auto 50px auto;
        line-height: 1.7;
      }

      .about-grid {
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
        gap: 30px;
        margin-top: 40px;
      }

      .about-card {
        background: #f8fafc;
        border: 1px solid #e2e8f0;
        border-radius: 14px;
        padding: 28px;
        transition: all 0.25s ease-in-out;
      }

      .about-card:hover {
        transform: translateY(-4px);
        box-shadow: 0 4px 16px rgba(0,0,0,0.07);
      }

      .card-title {
        font-size: 22px;
        font-weight: 700;
        margin-bottom: 10px;
        color: #0f172a;
      }

      .card-text {
        font-size: 15px;
        color: #64748b;
        line-height: 1.6;
      }

      /* ------------------------------------
         TABLER-STYLE SCROLL REVEAL ANIMATION
      -------------------------------------*/
      .reveal {
        opacity: 0;
        transform: translateY(30px);
        transition: all 0.8s cubic-bezier(0.23, 1, 0.32, 1);
      }

      .reveal.active {
        opacity: 1;
        transform: translateY(0);
      }

      /* Animation delay utilities */
      .delay-1 { transition-delay: 0.15s; }
      .delay-2 { transition-delay: 0.3s; }
      .delay-3 { transition-delay: 0.45s; }
      .delay-4 { transition-delay: 0.6s; }
      .delay-5 { transition-delay: 0.75s; }
      .delay-6 { transition-delay: 0.9s; }

      `}</style>

      <div className="about-container">
        <h2 className="about-title reveal">About Kryzen</h2>

        <p className="about-subtitle reveal delay-1">
          Kryzen Biotech is a leader in next-generation farming solutions. We
          combine hydroponic engineering, farm automation, agri-software, and
          AI-driven systems to build sustainable, high-yield farms across India
          and abroad.
        </p>

        <div className="about-grid">
          <div className="about-card reveal delay-1">
            <div className="card-title">End-to-End Expertise</div>
            <div className="card-text">
              We deliver complete solutions—from hydroponic farm design and
              installation to automation, crop planning, and long-term support.
            </div>
          </div>

          <div className="about-card reveal delay-2">
            <div className="card-title">Innovation at the Core</div>
            <div className="card-text">
              Our in-house systems like SmartFarmOS, climate automation, and AI
              analytics ensure high precision and reduced human error.
            </div>
          </div>

          <div className="about-card reveal delay-3">
            <div className="card-title">Trusted Across India</div>
            <div className="card-text">
              From commercial farms to education programs, we serve clients
              across industries and agricultural sectors.
            </div>
          </div>

          <div className="about-card reveal delay-4">
            <div className="card-title">Education & Growth</div>
            <div className="card-text">
              Webinars, farm trainings, and agri conferences help thousands
              learn hydroponics and controlled environment agriculture.
            </div>
          </div>

          <div className="about-card reveal delay-5">
            <div className="card-title">Precision & Sustainability</div>
            <div className="card-text">
              We promote climate-proof, resource-efficient systems using NFT,
              DWC, IoT automation, and nutrient sensors.
            </div>
          </div>

          <div className="about-card reveal delay-6">
            <div className="card-title">Customer-Centric Service</div>
            <div className="card-text">
              Every project receives dedicated guidance, monitoring, and
              lifetime support to ensure long-term success.
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
